export const mixinFilters = {
  capitalize: (value) => value.charAt(0).toUpperCase() + value.slice(1),
  zeropad: (number) => {
    if (number === null) {
      return '';
    } else if (number <= 99) {
      return `00${number}`.slice(-2);
    }
    return number;
  },
  percentage: (number) => {
    const val = (number * 100).toFixed(2);
    return `${val}%`;
  },
  round: (number, decimalsArg) => {
    let decimals = 0;
    if (decimalsArg) {
      decimals = decimalsArg;
    }
    const val = number.toFixed(decimals);
    return val;
  },
};
